'use client';

import { c as _c } from "react/compiler-runtime";
import { faBook, faCircleQuestion, faComments, faEnvelope, faGraduationCap, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@uzh-bf/design-system';
import Image from 'next/image';
interface CourseHelpDialogProps {
  isOpen: boolean;
  onClose: () => void;
  courseId: string;
  locale: string;
}
function CourseHelpDialog(t0) {
  const $ = _c(29);
  const {
    isOpen,
    onClose,
    courseId,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      content: "max-w-4xl max-h-[90vh] overflow-y-auto"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <h2 className="text-2xl font-bold">{"Hilfe & Unterst\xFCtzung"}</h2>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faTimes} className="w-5 h-5" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== onClose) {
    t4 = <div className="flex flex-row items-center justify-between border-b pb-4 mb-6">{t2}<button onClick={onClose} className="rounded-full p-2 hover:bg-gray-100 transition-colors">{t3}</button></div>;
    $[3] = onClose;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h3 className="text-lg font-semibold mb-4 text-gray-700">Lernmaterialien</h3>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `/${locale}/course/${courseId}/pages/it-support`;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FontAwesomeIcon icon={faInfoCircle} className="w-5 h-5 mt-1 text-blue-600" />;
    t8 = <div><div className="font-medium">Technische Informationen</div><div className="text-sm text-gray-600">Systemanforderungen und technische Details</div></div>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t7 = $[6];
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t6) {
    t9 = <a href={t6} className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 hover:border-uzh-blue hover:bg-gray-50 transition-colors">{t7}{t8}</a>;
    $[8] = t6;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href="https://docs.olat.uzh.ch/manual_user/learningresources/General_Information/" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 hover:border-uzh-blue hover:bg-gray-50 transition-colors"><FontAwesomeIcon icon={faGraduationCap} className="w-5 h-5 mt-1 text-purple-600" /><div><div className="font-medium">OLAT Kurs Tutorial</div><div className="text-sm text-gray-600">Einführung in die OLAT Kursplattform</div></div></a>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t9) {
    t11 = <div>{t5}<div className="space-y-3">{t9}{t10}</div></div>;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <h3 className="text-lg font-semibold mb-4 text-gray-700">{"Tools & Ressourcen"}</h3>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <a href="https://pwa.klicker.uzh.ch/docs" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 hover:border-uzh-blue hover:bg-gray-50 transition-colors"><FontAwesomeIcon icon={faCircleQuestion} className="w-5 h-5 mt-1 text-uzh-blue" /><div><div className="font-medium">KlickerUZH</div><div className="text-sm text-gray-600">Interaktives Audience Response System</div></div></a>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div>{t12}<div className="space-y-3">{t13}<a href="https://www.df.uzh.ch/financewiki/" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 hover:border-uzh-blue hover:bg-gray-50 transition-colors"><FontAwesomeIcon icon={faBook} className="w-5 h-5 mt-1 text-orange-600" /><div><div className="font-medium">Finance Wiki</div><div className="text-sm text-gray-600">Nachschlagewerk für Finanzthemen</div></div></a></div></div>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <h3 className="text-lg font-semibold mb-4 text-gray-700">{"Support & Kontakt"}</h3>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <a href="https://www.df.uzh.ch/de/studies/bachelor-master/community-df-studierende/newsletter-df-studierende.html" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 hover:border-uzh-blue hover:bg-gray-50 transition-colors w-full text-left"><FontAwesomeIcon icon={faComments} className="w-5 h-5 mt-1 text-green-600" /><div><div className="font-medium">Community Forum</div><div className="text-sm text-gray-600">Werde Teil der DF Community - jetzt anmelden!</div></div></a>;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="md:col-span-2">{t15}<div className="grid grid-cols-1 md:grid-cols-2 gap-3">{t16}<a href="mailto:tc-support@df.uzh.ch" className="flex items-start gap-3 p-4 rounded-lg border border-gray-200 hover:border-uzh-blue hover:bg-gray-50 transition-colors w-full text-left"><FontAwesomeIcon icon={faEnvelope} className="w-5 h-5 mt-1 text-red-600" /><div><div className="font-medium">E-Mail Support</div><div className="text-sm text-gray-600">Kontaktiere uns bei Fragen</div></div></a></div></div>;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t11) {
    t18 = <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-6">{t11}{t14}{t17}</div>;
    $[19] = t11;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="flex justify-center pt-6 border-t mt-6"><Image src="/uzh-logo-black.png" alt="UZH Logo" width={120} height={42} className="opacity-60" /></div>;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  let t20;
  if ($[22] !== t18 || $[23] !== t4) {
    t20 = <div className="p-6">{t4}{t18}{t19}</div>;
    $[22] = t18;
    $[23] = t4;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== isOpen || $[26] !== onClose || $[27] !== t20) {
    t21 = <Modal open={isOpen} onClose={onClose} hideCloseButton={true} className={t1}>{t20}</Modal>;
    $[25] = isOpen;
    $[26] = onClose;
    $[27] = t20;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  return t21;
}
export default CourseHelpDialog;